import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22a49529"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  ref: "sliderCarousel",
  id: "weddingSlider",
  class: "carousel slide wedding-slider",
  "data-bs-ride": "carousel"
}
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "carousel-caption d-none d-md-block"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#weddingSlider\" data-bs-slide=\"prev\" data-v-22a49529><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-22a49529></span><span class=\"visually-hidden\" data-v-22a49529>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#weddingSlider\" data-bs-slide=\"next\" data-v-22a49529><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-22a49529></span><span class=\"visually-hidden\" data-v-22a49529>Next</span></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.slides.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: slide.id,
                class: _normalizeClass(["carousel-item", {active: index === 0}])
              }, [
                _createElementVNode("img", {
                  src: slide.url,
                  class: "d-block slide-img",
                  alt: slide.title ? slide.title : 'no-title'
                }, null, 8, _hoisted_4),
                (slide.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h5", null, _toDisplayString(slide.title), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _hoisted_6
        ], 512)
      ]))
    : _createCommentVNode("", true)
}